<template>
  <div id="app">
    <div class="app flex-row align-items-center">
      <div class="container">
        <b-row class="justify-content-center">
          <b-col md="6">
            <div v-if="Busy == true">
              <div class="d-flex justify-content-center">
                <h1>Tukar Kata Laluan</h1>
              </div>
              <br />
              <div class="d-flex justify-content-center">
                <PulseLoader float />
              </div>
            </div>
            <div v-else>
              <b-card-group>
                <b-card no-body>
                  <b-card-body>
                    <b-form>
                      <h1 style="text-align:center">Tukar Kata Laluan</h1>
                      <br />
                      <label class="text-muted" style="text-align:center">Kata Laluan Semasa</label>
                      <b-input-group class="mb-3">
                        <b-input-group-prepend>
                          <b-input-group-text>
                            <i class="icon-lock"></i>
                          </b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input
                          autocomplete="new-password"
                          type="password"
                          class="form-control"
                          placeholder="Kata Laluan Semasa"
                          :disabled="Busy === true"
                          v-model="password"
                        />
                      </b-input-group>

                      <hr />
                      <label class="text-muted" style="text-align:center">Kata Laluan Baru</label>
                      <b-input-group class="mb-3">
                        <b-input-group-prepend>
                          <b-input-group-text>
                            <i class="icon-lock"></i>
                          </b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input
                          autocomplete="new-password"
                          type="password"
                          class="form-control"
                          placeholder="Kata Laluan Baru"
                          :disabled="Busy === true"
                          v-model="newPassword"
                        />
                      </b-input-group>
                      <b-alert
                        show
                        v-if="newPassword && !IsPasswordValid(newPassword)"
                        variant="danger"
                      >
                        Kata laluan perlu mengandungi sekurang-kurangnya
                        <br />• 8 hingga 20 aksara,
                        <br />• Satu huruf besar,
                        <br />• Satu huruf kecil, dan
                        <br />• Satu digit
                      </b-alert>
                      <b-input-group class="mb-3">
                        <b-input-group-prepend>
                          <b-input-group-text>
                            <i class="icon-lock"></i>
                          </b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input
                          autocomplete="new-password"
                          type="password"
                          class="form-control"
                          placeholder="Sahkan Kata Laluan Baru"
                          :disabled="Busy === true"
                          v-model="confirmNewPassword"
                        />
                      </b-input-group>
                      <span
                        class="error"
                        v-show="newPassword && confirmNewPassword && !IsPasswordEqual(newPassword, confirmNewPassword)"
                      >
                        <span style="color:red;">Kata laluan tidak sepadan.</span>
                        <hr />
                      </span>
                      <div style="text-align:center" class="mt-2">
                        <b-button
                          :disabled="!FormComplete"
                          variant="primary"
                          class="active mt-3 btn-block"
                          v-on:click="ChangePassword()"
                        >Tukar</b-button>
                      </div>
                      <b-button
                        variant="success"
                        block
                        :href="publicPath + '#/'"
                        class="mt-2"
                      >Kembali ke Laman Utama</b-button>
                    </b-form>
                  </b-card-body>
                </b-card>
              </b-card-group>
            </div>
            <div v-if="this.Error==true">
              <b-alert show variant="warning">{{this.Message}}</b-alert>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  name: "ChangePassword",
  e1: "#app",
  components: {
    PulseLoader
  },
  data: function() {
    return {
      publicPath: process.env.BASE_URL,

      password: "",
      newPassword: "",
      confirmNewPassword: "",

      Error: false,
      Message: ""
    };
  },
  computed: {
    Busy: {
      get: function() {
        return this.$store.getters["common/Busy"];
      },
      set: function(value) {
        this.$store.dispatch("common/updateBusy", value);
      }
    },
    FormComplete: {
      get: function() {
        if (
          this.IsPasswordValid(this.newPassword) &&
          this.IsPasswordEqual(this.newPassword, this.confirmNewPassword)
        )
          return true;
        else return false;
      }
    }
  },
  methods: {
    ChangePassword() {
      this.Message = "";
      this.Error = false;
      this.Busy = true;

      const formData = new FormData();
      formData.append("currentPassword", this.password);
      formData.append("newPassword", this.newPassword);

      return this.$API
        .post(this.$ChangePassword, formData, {
          withCredentials: true
        })
        .then(response => {
          this.info = response.data;
          this.Busy = false;

          if (response.status == 200 && this.info != null) {
            if (this.info.status == 500) {
              this.Error = true;
              this.Message = this.info.detail;
              this.$dialog.alert("Tindakan tidak berjaya.");
            } else {
              this.password = "";
              this.newPassword = "";
              this.confirmNewPassword = "";
              this.$dialog.alert("Kata laluan berjaya ditukar.");
            }
          } else {
            this.Error = true;
            this.Message = this.info.detail;
            this.$dialog.alert("Tindakan tidak berjaya.");
          }
        })
        .catch(error => {
          this.Error = true;
          this.Message = error;
          this.$dialog.alert("Tindakan tidak berjaya.");
        });
    }
  }
};
</script>
